export const grade_1 = '1 Klasė';
export const grade_2 = '2 Klasė';
export const grade_3 = '3 Klasė';
export const grade_4 = '4 Klasė';
export const grade_5 = '5 Klasė';
export const grade_6 = '6 Klasė';
export const grade_7 = '7 Klasė';
export const grade_8 = '8 Klasė';
export const grade_9 = '9 Klasė';
export const grade_10 = '10 Klasė';
export const grade_11 = '11 Klasė';
export const grade_12 = '12 Klasė';

export const grades = {
  grade_1,
  grade_2,
  grade_3,
  grade_4,
  grade_5,
  grade_6,
  grade_7,
  grade_8,
  grade_9,
  grade_10,
  grade_11,
  grade_12,
};
